import type { Ref } from 'vue'
import { ref, readonly } from 'vue'

export interface UseThreeDControlEvents {
  isControlling: Readonly<Ref<boolean>>
  startControl(e: MouseEvent): void
  stopControl(e: MouseEvent): void
  wheel(): void
}

export function useThreeDControlEvents(): UseThreeDControlEvents {
  const isControlling = ref(false)

  let _indicatorTimeout: NodeJS.Timeout

  function startControl(e: MouseEvent) {
    // MouseEvent.buttons is a bitmask
    // left (1), right (2), or middle click (4)
    if ((e.buttons & 7) !== 0) {
      isControlling.value = true
      clearTimeout(_indicatorTimeout)
    }
  }

  function stopControl(e: MouseEvent) {
    if ((e.buttons & 7) === 0) {
      isControlling.value = false
    }
  }

  function wheel() {
    isControlling.value = true

    clearTimeout(_indicatorTimeout)
    _indicatorTimeout = setTimeout(() => {
      isControlling.value = false
    }, 500)
  }

  return {
    isControlling: readonly(isControlling),
    startControl,
    stopControl,
    wheel,
  }
}
